import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

const NODE_STATES = {
  EMPTY: "EMPTY",
  COMPLETE: "COMPLETE",
  CURRENT: "CURRENT",
};

/**
 * RectDragDropRow:
 *  - Render BOX_DRAG_DROP component of DesignSection
 */
export function RectDragDropRow(props) {
  const onCardDrop = (params) => {
    props.dropItem({
      positionID: params.positionId,
      componentID: params.optionID,
      nodeId: props.nodeId,
    });
  };

  const onRemoveCard = (positionId) => {
    props.removeItem({
      nodeId: props.nodeId,
      positionID: positionId,
    });
  };

  const renderRectNode = (node, key) =>
    React.cloneElement(props.nodeHolder, {
      key: key,
      positionId: node.id,
      droppedId: node.droppedId,
      image: node.image,
      modal: node.modal,
      title: node.title,
      description: node.description,
      removeCard: onRemoveCard,
      dropItem: onCardDrop,
      feedbackMessage: props.nodeFeedback[node.id],
    });

  const wrapperClass = () => {
    return props.nodeState === NODE_STATES.COMPLETE
      ? "rectRowWrap-complete"
      : "rectRowWrap";
  };

  if (props.nodeState === NODE_STATES.EMPTY) {
    return null;
  } else {
    return (
      <div className={wrapperClass()}>
        {props.nodeComponents.map(renderRectNode)}
      </div>
    );
  }
}

RectDragDropRow.propTypes = {
  /**
   * Unique Id for the node
   */
  nodeId: PropTypes.number.isRequired,
  /**
   *Function to invoke when a card is dropped in holder.
   */
  dropItem: PropTypes.func,
  /**
   * Function to invoke when remove card button is pressed
   */
  removeItem: PropTypes.func,
  /**
   * List Of components to be displayed in Row
   */
  nodeComponents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      droppedId: PropTypes.number,
      image: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      modal: PropTypes.object,
    })
  ).isRequired,
  /**
   * Holder Component for FULL_WIDTH_CARD
   */
  nodeHolder: PropTypes.element.isRequired,
  /**
   * Object with error feedback messages for the position;
   * Identified by position Id
   */
  nodeFeedback: PropTypes.object.isRequired,
  /**
   * State of the Row. One of ['EMPTY','CURRENT', 'COMPLETE']
   */
  nodeState: PropTypes.oneOf(["EMPTY", "CURRENT", "COMPLETE"]).isRequired,
};

RectDragDropRow.defaultProps = {
  nodeState: NODE_STATES.EMPTY,
  nodeComponents: [],
};
